import {Box, Button, Grid, MenuItem, Select, Step, StepLabel, Stepper, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {PlatformType} from "crqlar-react-common/dist/models/newsletter/platformType";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";

interface Props {
    handleNext: () => void
    activeStep: number
    platformType: string
    handlePlatformChange: (value: string) => void
    platformOptions: PlatformType[]
}

const ChannelSetup = (props: Props) => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    const readOnlyUser = useReadOnly()

    return (
        <Box sx={{p: 4, maxWidth: '1200px', margin: 'auto'}}>
            <Typography variant="h4" gutterBottom sx={{mb: 4}}>
                {t('Ad Account Setup')}
            </Typography>
            <Stepper activeStep={props.activeStep} sx={{mb: 4}}>
                <Step>
                    <StepLabel>{t('Select Channel')}</StepLabel>
                </Step>
                <Step>
                    <StepLabel>{t('Account Setup')}</StepLabel>
                </Step>
            </Stepper>
            <Box component="form" sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
                <Box>
                    <Typography variant="h4" gutterBottom>
                        {t('General')}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    <Grid item sx={{display: 'flex', gap: 2}} md={6} xs={12}>
                        <Select
                            sx={{height: '60px'}}
                            fullWidth
                            labelId="platform-label"
                            id="platform"
                            value={props.platformType}
                            onChange={(e) => props.handlePlatformChange(e.target.value)}
                        >
                            {props.platformOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Typography variant="body1" sx={{lineHeight: '1.5', paddingLeft: '20px'}}>
                            1. {t('Connect Ad Account with Crqlar')}
                            <Typography component="div">
                                <ul style={{margin: 0, lineHeight: '1.5'}}>
                                    <li>{t('Click "Connect Ad Account with Crqlar"')}</li>
                                    <li>{t('Follow instructions in the popup window and authorize Crqlar CRM (or your app) to access data')}</li>
                                </ul>
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item md={6} xs={12}></Grid>

                    <Grid item md={6} xs={12}>
                        <Typography variant="body1" sx={{lineHeight: '1.5', paddingLeft: '20px'}}>
                            2. {t('Select Ad Account')}
                            <Typography component="div">
                                <ul style={{margin: 0, lineHeight: '1.5'}}>
                                    <li>{t('Select the customer id you want to use for the CRM')}</li>
                                </ul>
                            </Typography>
                        </Typography>
                    </Grid>

                </Grid>

                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button
                        disabled={props.platformType === 'GOOGLE_ADS' || readOnlyUser}
                        variant="text"
                        startIcon={<ArrowBackIcon/>}
                        onClick={() => navigate(-1)}
                    >
                        {t('Back')}
                    </Button>
                    <Button
                        disabled={props.platformType === 'GOOGLE_ADS' || readOnlyUser}
                        variant="contained"
                        color="primary"
                        sx={{backgroundColor: '#21cbf5'}}
                        endIcon={<ArrowForwardIcon/>}
                        onClick={props.handleNext}
                    >
                        {t('Continue to Credentials')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default ChannelSetup
